/**
 * Universal Table Filtering
 *
 * Provides real-time client-side filtering for tables and grids with data attributes.
 * Works with the universal search input field to filter items as you type.
 */

document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('input[name="search"]');

  if (!searchInput) return;

  // Find all filterable elements
  const filterableItems = [];

  // Find table rows
  const tables = document.querySelectorAll('table tbody[id]');
  tables.forEach(tbody => {
    const rows = tbody.querySelectorAll('tr[data-name], tr[data-network], tr[data-username], tr[data-email]');
    rows.forEach(row => filterableItems.push(row));
  });

  // Find grid items (like tunnel cards)
  const grids = document.querySelectorAll('#tunnels-grid > div[data-name]');
  grids.forEach(card => filterableItems.push(card));

  if (filterableItems.length === 0) return;

  // Add input event listener for real-time filtering
  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.toLowerCase().trim();

    filterableItems.forEach(item => {
      if (!searchTerm) {
        // Show all items if search is empty
        item.style.display = '';
        return;
      }

      // Get all data attributes from the item
      const dataAttrs = item.dataset;

      // Check if search term matches any data attribute value
      const matches = Object.values(dataAttrs).some(value => {
        if (!value) return false;
        return value.toString().toLowerCase().includes(searchTerm);
      });

      item.style.display = matches ? '' : 'none';
    });
  });
});
